window.addEventListener("klaviyoForms", function (event) {
  if (event.detail.type !== "submit") return;

  const KLAVIYO_CONTACT_FORM_IDS = ["Ytfawe", "XteMd2"];
  if (!KLAVIYO_CONTACT_FORM_IDS.includes(event.detail.formId)) return;

  const container = document.querySelector(".contact-form-newsletter");
  const pageId = container?.dataset.klaviyoThankyouPageId || "";
  const pageName = container?.dataset.klaviyoThankyouPageName || "";

  const thankYouUrl = new URL("/pages/thank-you", window.location.origin);
  if (pageId) thankYouUrl.searchParams.set("pid", pageId);
  if (pageName) thankYouUrl.searchParams.set("pname", pageName);

  window.location.href = thankYouUrl.toString();
});

document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(() => {
    const form = document.querySelector(".klaviyo-form-Ytfawe form");
    const submitBtn = form?.querySelector("button.kl-private-reset-css-Xuajs1");

    if (form && submitBtn && !form.dataset.validationAttached) {
      form.dataset.validationAttached = "true";
      observer.disconnect();
      attachCustomValidation(form, submitBtn);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  function attachCustomValidation(form, submitBtn) {
    function validateFields() {
      let isValid = true;
      let messages = [];

      const phoneField = form.querySelector("#Phone_Number_01JRHY5MZ5RJT8HNG8QP5TJSXP");
      const urlField = form.querySelector("#Website_URL_01JRHY5MZ8BNH51G1ZNHFNSM4R");

      const phoneRegex = /^\+?[\d\s\-().]{7,15}$/;
      const urlRegex = /^(https?:\/\/|www\.)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}([\/\w.-]*)*\/?$/;

      if (phoneField && !phoneRegex.test(phoneField.value.trim())) {
        messages.push("Please enter a valid phone number.");
        isValid = false;
      }

      if (urlField && !urlRegex.test(urlField.value.trim())) {
        messages.push("Please enter a valid website URL.");
        isValid = false;
      }

      if (!isValid) {
        alert(messages.join("\n"));
      }

      return isValid;
    }

    form.addEventListener("submit", function (e) {
      if (!validateFields()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    }, true);

    submitBtn.addEventListener("click", function (e) {
      if (!validateFields()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      } else {
        // Manually trigger submission if valid
        if (typeof form.requestSubmit === "function") {
          form.requestSubmit();
        } else {
          form.submit();
        }
      }
    }, true);
  }
});